<template>
<el-row>
  <el-col :span="24">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.province_code, message: `请选择正确的所在省份`, trigger: 'change' }
          ]"
          prop="company_content.province_code"
        >
          <div class="form-item-label" solt="label">
            所在省份
          </div>
          <el-select v-model="onJobInfo.company_content.province_code" placeholder="选择省份" @change="changeProvince">
            <el-option v-for="(value, key) in pcds[86]" :key="key" :label="value" :value="+key"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.city_code, message: `请选择正确的所在城市`, trigger: 'change' }
          ]"
          prop="company_content.city_code"
        >
          <div class="form-item-label" solt="label">
            所在城市
          </div>
          <el-select v-model="onJobInfo.company_content.city_code" placeholder="选择城市" @change="changeCity">
            <el-option v-for="(value, key) in pcds[onJobInfo.company_content.province_code]" :key="key" :label="value" :value="+key"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.company_tel, message: `请输入正确的公司电话`, trigger: 'blur' }
          ]"
          prop="company_content.company_tel"
        >
          <div class="form-item-label" solt="label">
            公司电话
          </div>
          <el-input v-model.trim="onJobInfo.company_content.company_tel" :maxlength="30" placeholder="请填写"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="0">
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.detail_addr, message: `请输入正确的详细地址 (中文)`, trigger: 'blur' }
          ]"
          prop="company_content.detail_addr"
        >
          <div class="form-item-label" solt="label">
            详细地址 (中文)
          </div>
          <el-input
            v-model.trim="onJobInfo.company_content.detail_addr"
            type="textarea"
            :rows="3"
            placeholder="请填写，自动翻译为英文"
            @blur="handleAutoTranslate(onJobInfo.company_content.detail_addr, 'detail_addr_en')"
            :maxlength="100"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="2">
        <div class="translate-box">
          <div class="translate-img"></div>
        </div>
      </el-col>
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.detail_addr_en, message: `请输入正确的详细地址 (英文)`, trigger: 'blur' }
          ]"
          prop="company_content.detail_addr_en"
        >
          <div class="form-item-label" solt="label">
            详细地址 (英文)
          </div>
          <el-input v-model.trim="onJobInfo.company_content.detail_addr_en" type="textarea" :rows="3" placeholder="" :maxlength="300"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.leader_name, message: `请输入正确的领导姓名 (拼音/英文)`, trigger: 'blur' }
          ]"
          prop="company_content.leader_name"
        >
          <div class="form-item-label" solt="label">
            领导姓名 (拼音/英文)
          </div>
          <el-input v-model.trim="onJobInfo.company_content.leader_name" :maxlength="30" placeholder="请填写"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="0">
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.leader_job, message: `请输入正确的领导职务 (中文)`, trigger: 'blur' }
          ]"
          prop="company_content.leader_job"
        >
          <div class="form-item-label" solt="label">
            领导职务 (中文)
          </div>
          <el-input v-model.trim="onJobInfo.company_content.leader_job" :maxlength="30" placeholder="请填写，自动翻译为英文" @blur="handleAutoTranslate(onJobInfo.company_content.leader_job, 'leader_job_en')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="2">
        <div class="translate-box">
          <div class="translate-img"></div>
        </div>
      </el-col>
      <el-col :span="11">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.leader_job_en, message: `请输入正确的领导职务 (英文)`, trigger: 'blur' }
          ]"
          prop="company_content.leader_job_en"
        >
          <div class="form-item-label" solt="label">
            领导职务 (英文)
          </div>
          <el-input v-model.trim="onJobInfo.company_content.leader_job_en" :maxlength="300" placeholder=""></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.company_content.closing_date, message: `请输入正确的落款日期`, trigger: 'change' }
          ]"
          prop="company_content.closing_date"
        >
          <div class="form-item-label" solt="label">
            落款日期 (开具证明的真实日期)
          </div>
          <el-date-picker
            :value="onJobInfo.company_content.closing_date"
            type="date"
            placeholder="选择日期"
            @input="handleChangeDate($event, 'closing_date')"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
  </el-col>
</el-row>
</template>

<script>
import moment from 'moment';
import pcdService from '../../../services/pcd-service';
import translateService from '../../../services/translate-service';

export default {
  props: {
    onJobInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    checkConfig: {
      type: Object,
    },
  },
  data() {
    return {
      pcds: [],
    };
  },
  created() {
    pcdService.getPcd().then((pcds) => {
      this.pcds = pcds;
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
  methods: {
    // 翻译
    handleAutoTranslate(text, field) {
      if (!text) return;
      translateService.translateEn(text).then((translateText) => {
        this.$set(this.onJobInfo.company_content, field, translateText);
      });
    },
    changeProvince() {
      this.$set(this.onJobInfo.company_content, 'city_code', undefined);
      const province_cn = this.pcds[86][this.onJobInfo.company_content.province_code];
      this.handleAutoTranslate(province_cn, 'province_en');
    },
    changeCity() {
      const city_cn = this.pcds[this.onJobInfo.company_content.province_code] ?
        this.pcds[this.onJobInfo.company_content.province_code][this.onJobInfo.company_content.city_code] :
        undefined;
      this.handleAutoTranslate(city_cn, 'city_en');
    },
    handleChangeDate(date, field) {
      if (!date) {
        this.$set(this.onJobInfo.company_content, field, '');
      } else {
        this.$set(this.onJobInfo.company_content, field, moment(date).format('YYYY-MM-DD'));
      }
    },
  },
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/edit-form-company.vue